var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"6","offset":"3"}},[_c('br'),_c('v-alert',{attrs:{"border":"right","colored-border":"","type":"error","elevation":"2"}},[_vm._v(" 404 - Página não encontrada. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }